"use strict";
(globalThis["webpackChunkweb"] = globalThis["webpackChunkweb"] || []).push([[2747],{

/***/ 17363:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Tg: () => (/* binding */ DocsDarkTheme),
/* harmony export */   W6: () => (/* binding */ DocsLightTheme),
/* harmony export */   r6: () => (/* binding */ ReadmeTheme)
/* harmony export */ });
/* unused harmony exports proseFamily, SpaciousContentBreakpoint, SidebarNavBreakpoint, ThreeColumnNavBreakpoint, WideSidebarNavBreakpoint, DISCORD_INVITE_URL, generateTypography, DocsNarrowLightTheme, AreaColors */
/* harmony import */ var baseui__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70531);
/* harmony import */ var lodash_merge__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88469);
/* harmony import */ var lodash_merge__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_merge__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _EditTheme__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37695);
/* harmony import */ var _primitives__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75580);




const proseFamily = `Helvetica, -apple-system, BlinkMacSystemFont, sans-serif`;
const SpaciousContentBreakpoint = (/* unused pure expression or super */ null && (`(min-width: 1180px)`));
const SidebarNavBreakpoint = (/* unused pure expression or super */ null && (`(min-width: 850px)`));
const ThreeColumnNavBreakpoint = (/* unused pure expression or super */ null && (`(min-width: 1180px)`));
const WideSidebarNavBreakpoint = (/* unused pure expression or super */ null && (`(min-width: 1400px)`));
const getColorOverrides = (colors)=>{
    return {
        ...colors,
        inputTextDisabled: colors.primary400,
        inputFillDisabled: colors.primary50,
        inputFill: colors.neutralMin,
        inputFillActive: colors.neutralMin,
        inputBorder: colors.primary200,
        borderFocus: colors.electricBlue500,
        borderSelected: colors.electricBlue400,
        contentPrimary: colors == _primitives__WEBPACK_IMPORTED_MODULE_1__/* .gadgetColorsDark */ .Ql ? colors.neutralMax : "#0B0B0F",
        codePink: "#FD2189",
        guidesBlue: "#4242FC",
        apiGrey: "#000000",
        gellyPurple: "#9B50D7",
        contentDevelopment: colors.development,
        contentProduction: colors.purple500,
        contentAccent: colors.electricBlue400,
        linkText: colors.electricBlue500,
        linkVisited: colors.electricBlue500,
        linkHover: colors.electricBlue600,
        contentLinkText: colors.electricBlue500,
        contentLinkHover: colors.electricBlue600,
        contentLinkActive: colors.electricBlue700
    };
};
// Derived from https://github.com/gadget-inc/baseweb/blob/build-1b4286d28/themes/shared/typography.js#L155-L172
const PrimitiveTypographyMap = {
    ParagraphXSmall: "font100",
    ParagraphSmall: "font200",
    ParagraphMedium: "font300",
    ParagraphLarge: "font400",
    LabelXSmall: "font150",
    LabelSmall: "font250",
    LabelMedium: "font350",
    LabelLarge: "font450",
    HeadingXSmall: "font550",
    HeadingSmall: "font650",
    HeadingMedium: "font750",
    HeadingLarge: "font850",
    HeadingXLarge: "font950",
    HeadingXXLarge: "font1050",
    DisplayXSmall: "font1150",
    DisplaySmall: "font1250",
    DisplayMedium: "font1350",
    DisplayLarge: "font1450",
    contentLink: "contentLink"
};
const DISCORD_INVITE_URL = "https://ggt.link/discord";
/**
 * BaseUI has a bunch of redundant typography styles that can be
 * derived from a smaller set of primitives. This helper generates
 * those redundant styles.
 */ const generateTypography = (primitive)=>Object.fromEntries(Object.entries(PrimitiveTypographyMap).flatMap(([name, fontCode])=>{
        const { primaryFont: primitivePrimaryFont = {}, monoFont: primitiveMonoFont = {}, ...primitiveBaseFont } = primitive.typography ? primitive.typography[name] ?? {} : {};
        const primaryFont = {
            ...primitive.primaryFontFamily ? {
                fontFamily: primitive.primaryFontFamily
            } : {},
            ...primitiveBaseFont,
            ...primitivePrimaryFont
        };
        const monoFont = {
            ...primitive.monoFontFamily ? {
                fontFamily: primitive.monoFontFamily
            } : {},
            ...primitiveBaseFont,
            ...primitiveMonoFont
        };
        return [
            [
                fontCode,
                primaryFont
            ],
            [
                name,
                primaryFont
            ],
            [
                `Mono${name}`,
                monoFont
            ]
        ];
    }));
const defaultDocsTypography = {
    primaryFontFamily: proseFamily,
    monoFontFamily: _EditTheme__WEBPACK_IMPORTED_MODULE_2__/* .monoFontFamily */ .CK,
    typography: {
        ParagraphXSmall: {
            fontWeight: "normal",
            fontSize: "14px",
            lineHeight: "22px"
        },
        ParagraphSmall: {
            fontWeight: "normal",
            primaryFont: {
                fontSize: "14px",
                lineHeight: "22px"
            },
            monoFont: {
                fontSize: "15px",
                lineHeight: "20px"
            }
        },
        ParagraphMedium: {
            fontWeight: "normal",
            primaryFont: {
                /* Docs & Web/Body */ fontSize: "16px",
                lineHeight: "26px"
            },
            monoFont: {
                fontWeight: "normal",
                fontSize: "17px",
                lineHeight: "25px"
            }
        },
        LabelXSmall: {
            primaryFont: {
                fontWeight: "normal",
                fontSize: "12px",
                lineHeight: "16px"
            },
            monoFont: {
                /* button, search, etc */ fontWeight: 500,
                fontSize: "14px",
                lineHeight: "20px"
            }
        },
        LabelSmall: {
            fontWeight: "normal",
            lineHeight: "20px",
            primaryFont: {
                fontSize: "14px"
            },
            monoFont: {
                fontSize: "15px"
            }
        },
        LabelMedium: {
            primaryFont: {
                fontWeight: 500,
                fontSize: "16px",
                lineHeight: "20px"
            },
            monoFont: {
                fontWeight: "normal",
                fontSize: "17px",
                lineHeight: "25px"
            }
        },
        HeadingXSmall: {
            /* H4 */ fontWeight: 700,
            fontSize: "15px",
            lineHeight: "140%"
        },
        HeadingSmall: {
            /* H3 */ fontWeight: 700,
            fontSize: "18px",
            lineHeight: "22px"
        },
        HeadingMedium: {
            /* SectionHeading - H2 */ fontWeight: 700,
            fontSize: "24px",
            lineHeight: "32px"
        },
        HeadingLarge: {
            /* PageHeading - H1 */ fontWeight: 700,
            fontSize: "32px",
            lineHeight: "32px"
        },
        HeadingXLarge: {
            /* PageHeading - H1 */ fontWeight: 700,
            fontSize: "32px",
            lineHeight: "32px"
        },
        DisplaySmall: {
            /* Display */ fontWeight: 700,
            fontSize: "42px",
            lineHeight: "53px"
        },
        contentLink: {
            textDecoration: "none"
        }
    }
};
const docsOverrides = {
    name: "docs",
    grid: _EditTheme__WEBPACK_IMPORTED_MODULE_2__/* .editOverrides */ .f8.grid,
    lighting: {
        shadow400: "0 1px 0px hsla(0, 0%, 0%, 0.05)",
        shadow500: "0px 2px 1px rgba(0, 0, 0, 0.05), 0px 0px 1px rgba(0, 0, 0, 0.25)",
        shadow600: "0px 0px 2px rgba(0, 0, 0, 0.2), 0px 2px 10px rgba(0, 0, 0, 0.1)",
        shadow700: "0px 0px 3px rgba(0, 0, 0, 0.1), 0px 4px 20px rgba(0, 0, 0, 0.15)"
    },
    typography: generateTypography(defaultDocsTypography),
    borders: {
        useRoundedCorners: true,
        inputBorderRadius: "8px",
        buttonBorderRadius: "2px",
        popoverBorderRadius: "2px",
        surfaceBorderRadius: "8px"
    },
    colors: getColorOverrides(_primitives__WEBPACK_IMPORTED_MODULE_1__/* .gadgetColorsLight */ .d_)
};
const readmeOverrides = {
    ...docsOverrides,
    name: "readme",
    typography: generateTypography({
        ...defaultDocsTypography,
        primaryFontFamily: "Inconsolata"
    })
};
const breakpoints = {
    mini: 320,
    xsmall: 800,
    small: 1000,
    medium: 1100,
    large: 1440,
    xlarge: 1790
};
const responsiveCustomTheme = Object.keys(breakpoints).reduce((acc, key)=>{
    acc.mediaQuery[key] = `@media screen and (min-width: ${breakpoints[key]}px)`;
    return acc;
}, {
    breakpoints,
    mediaQuery: {}
});
docsOverrides.mediaQuery = responsiveCustomTheme.mediaQuery;
docsOverrides.breakpoints = responsiveCustomTheme.breakpoints;
const docsDarkOverrides = {
    ...docsOverrides,
    colors: getColorOverrides(_primitives__WEBPACK_IMPORTED_MODULE_1__/* .gadgetColorsDark */ .Ql)
};
const DocsLightTheme = (0,baseui__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_EditTheme__WEBPACK_IMPORTED_MODULE_2__/* .primitivesLight */ .Kc, docsOverrides);
const DocsDarkTheme = (0,baseui__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_EditTheme__WEBPACK_IMPORTED_MODULE_2__/* .primitivesDark */ .sb, docsDarkOverrides);
if (typeof window != "undefined") {
    window.DocsLightTheme = DocsLightTheme;
    window.DocsDarkTheme = DocsDarkTheme;
}
const DocsNarrowLightTheme = (0,baseui__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_EditTheme__WEBPACK_IMPORTED_MODULE_2__/* .primitivesLight */ .Kc, lodash_merge__WEBPACK_IMPORTED_MODULE_0___default()({}, docsOverrides, {
    name: "docs-narrow",
    typography: {
        ...docsOverrides.typography
    }
}));
const ReadmeTheme = (0,baseui__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_EditTheme__WEBPACK_IMPORTED_MODULE_2__/* .primitivesLight */ .Kc, lodash_merge__WEBPACK_IMPORTED_MODULE_0___default()({}, docsOverrides, {
    name: "readme",
    typography: {
        ...readmeOverrides.typography
    }
}));
const AreaColors = {
    code: "codePink",
    gelly: "gellyPurple",
    guides: "guidesBlue",
    api: "apiGrey"
};


/***/ }),

/***/ 63582:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   H6: () => (/* binding */ ExpandableCardSection),
/* harmony export */   OY: () => (/* binding */ StyledCardTitle),
/* harmony export */   Zb: () => (/* binding */ Card),
/* harmony export */   di: () => (/* binding */ StyledCardTitleContainer),
/* harmony export */   uO: () => (/* binding */ CardSection)
/* harmony export */ });
/* harmony import */ var baseui__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10334);
/* harmony import */ var lodash_defaultTo__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48908);
/* harmony import */ var lodash_defaultTo__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_defaultTo__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lodash_omit__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73352);
/* harmony import */ var lodash_omit__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_omit__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30242);
/* harmony import */ var _icons_AccordionExpandIcon__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(49325);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1898);
/* harmony import */ var _utils_overrides__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(37307);
/* harmony import */ var _Column__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(74888);
/* harmony import */ var _Row__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(73830);









const StyledCardRoot = (0,baseui__WEBPACK_IMPORTED_MODULE_3__/* .styled */ .zo)("div", ({ $theme, $active, $focused, $spaced, $nested, $flat })=>{
    return {
        ...(0,_utils__WEBPACK_IMPORTED_MODULE_4__/* .expandPadding */ .ft)(lodash_defaultTo__WEBPACK_IMPORTED_MODULE_0___default()($spaced, true) ? $theme.sizing.scale600 : "0px"),
        ...(0,_utils__WEBPACK_IMPORTED_MODULE_4__/* .expandBorderRadii */ .uJ)($theme.borders.surfaceBorderRadius),
        ...(0,_utils__WEBPACK_IMPORTED_MODULE_4__/* .expandBaseWebBorder */ .yc)({
            borderWidth: $theme.borders.border100.borderWidth,
            borderColor: $active && $focused ? $theme.colors.borderSelected : $theme.colors.borderOpaque,
            borderStyle: "solid"
        }),
        backgroundColor: $theme.colors.background,
        outlineWidth: $focused ? "2px" : $active ? "1px" : "0px",
        outlineStyle: "solid",
        outlineColor: $theme.colors.borderSelected,
        boxShadow: $nested ? "0px -1px 0px 0px rgba(0, 0, 0, 0.24) inset, 0px 1px 1px 0px rgba(0, 0, 0, 0.16)" : $flat ? undefined : $theme.lighting.depth2,
        ...$theme.typography.LabelSmall
    };
});
const StyledCardRootSecondary = (0,baseui__WEBPACK_IMPORTED_MODULE_3__/* .withStyle */ .w1)(StyledCardRoot, (props)=>{
    return {
        backgroundColor: "transparent",
        ...(0,_utils__WEBPACK_IMPORTED_MODULE_4__/* .expandBorderColors */ .gC)(props.$active ? props.$theme.colors.alpha500 : props.$theme.colors.alpha300),
        boxShadow: props.$active ? props.$theme.lighting.shadowButtonInset : "none",
        outlineWidth: props.$focused ? "2px" : "0px",
        outlineOffset: props.$focused ? "1px" : "0px",
        paddingBottom: props.$theme.sizing.scale500
    };
});
const StyledCardTitleContainer = (0,baseui__WEBPACK_IMPORTED_MODULE_3__/* .styled */ .zo)("div", ({ $theme })=>{
    return {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        gap: $theme.sizing.scale400,
        justifyContent: "space-between"
    };
});
const StyledCardTitle = (0,baseui__WEBPACK_IMPORTED_MODULE_3__/* .styled */ .zo)("div", ({ $theme })=>{
    return {
        ...$theme.typography.subHeading,
        marginBottom: $theme.sizing.scale400
    };
});
const StyledCardSubtitle = (0,baseui__WEBPACK_IMPORTED_MODULE_3__/* .styled */ .zo)("div", ({ $theme })=>{
    return {
        ...$theme.typography.LabelMedium,
        marginBottom: $theme.sizing.scale400
    };
});
/** A rectangular box around some content */ const Card = (props)=>{
    const { Root, Title, TitleContainer, Subtitle } = (0,_utils_overrides__WEBPACK_IMPORTED_MODULE_5__/* .useOverrides */ .QG)({
        Root: props.variant == "secondary" ? StyledCardRootSecondary : StyledCardRoot,
        TitleContainer: StyledCardTitleContainer,
        Title: StyledCardTitle,
        Subtitle: StyledCardSubtitle
    }, props.overrides);
    // add padding to this card by default, but don't if explicitly told not to, or if the card contains card sections, which add their own padding
    const spaced = props.$spaced ?? !react__WEBPACK_IMPORTED_MODULE_2__.Children.toArray(props.children).every((child)=>{
        return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.isValidElement(child) && child.type.displayName === "CardSection";
    });
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.createElement(Root, {
        ...lodash_omit__WEBPACK_IMPORTED_MODULE_1___default()(props, [
            "title"
        ]),
        $spaced: spaced
    }, (props.title || props.titleAction) && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.createElement(TitleContainer, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.createElement("div", null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.createElement(Title, null, props.title), props.subtitle && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.createElement(Subtitle, null, props.subtitle)), props.titleAction), props.children);
};
const CardSection = (props)=>{
    const [css, $theme] = (0,baseui__WEBPACK_IMPORTED_MODULE_3__/* .useStyletron */ .hQ)();
    const padding = props.$padding == "xsmall" ? $theme.sizing.scale300 : props.$padding == "small" ? $theme.sizing.scale500 : $theme.sizing.scale600;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.createElement(_Column__WEBPACK_IMPORTED_MODULE_6__/* .Column */ .s, {
        "data-testid": props["data-testid"],
        onMouseEnter: props.onMouseEnter,
        onMouseLeave: props.onMouseLeave,
        onClick: props.onClick,
        $as: props.$as ?? "section",
        $gap: $theme.sizing.scale500,
        $style: {
            backgroundColor: props.variant === "secondary" ? $theme.colors.backgroundSecondary : "transparent",
            ...(0,_utils__WEBPACK_IMPORTED_MODULE_4__/* .paddingUtil */ .N1)(padding),
            ...props.$ruled ? (0,_utils__WEBPACK_IMPORTED_MODULE_4__/* .expandBorderBottom */ .lK)({
                borderWidth: $theme.borders.border100.borderWidth,
                borderColor: $theme.colors.borderOpaque,
                borderStyle: "solid"
            }) : undefined,
            ":last-child": {
                borderBottomWidth: 0,
                borderBottomLeftRadius: $theme.borders.surfaceBorderRadius,
                borderBottomRightRadius: $theme.borders.surfaceBorderRadius
            },
            ":first-child": {
                borderTop: undefined,
                borderTopLeftRadius: $theme.borders.surfaceBorderRadius,
                borderTopRightRadius: $theme.borders.surfaceBorderRadius
            },
            ...lodash_omit__WEBPACK_IMPORTED_MODULE_1___default()(props.$style, "appearance") ?? {}
        }
    }, props.children);
};
CardSection.displayName = "CardSection";
const ExpandableCardSection = (props)=>{
    const [isOpen, setIsOpen] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
    const [_, $theme] = (0,baseui__WEBPACK_IMPORTED_MODULE_3__/* .useStyletron */ .hQ)();
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.createElement(_Column__WEBPACK_IMPORTED_MODULE_6__/* .Column */ .s, {
        $style: {
            ...(0,_utils__WEBPACK_IMPORTED_MODULE_4__/* .expandBorderBottom */ .lK)({
                borderWidth: $theme.borders.border100.borderWidth,
                borderColor: $theme.colors.borderOpaque,
                borderStyle: "solid"
            }),
            ":last-child": {
                borderBottomWidth: 0,
                borderBottomLeftRadius: $theme.borders.surfaceBorderRadius,
                borderBottomRightRadius: $theme.borders.surfaceBorderRadius
            },
            ...props.$style
        }
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.createElement(_Row__WEBPACK_IMPORTED_MODULE_7__/* .Row */ .X, {
        $gap: $theme.sizing.scale300,
        $style: {
            cursor: "pointer",
            ...(0,_utils__WEBPACK_IMPORTED_MODULE_4__/* .paddingVertical */ .i6)($theme.sizing.scale200),
            ...(0,_utils__WEBPACK_IMPORTED_MODULE_4__/* .paddingHorizontal */ .WB)($theme.sizing.scale300),
            ":hover": {
                backgroundColor: $theme.colors.alpha50
            }
        },
        onClick: ()=>{
            if (isOpen && props.onCollapse) {
                props.onCollapse();
            } else if (!isOpen && props.onExpand) {
                props.onExpand();
            }
            setIsOpen(!isOpen);
        }
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.createElement(_icons_AccordionExpandIcon__WEBPACK_IMPORTED_MODULE_8__/* .AccordionExpandIcon */ .K, {
        direction: isOpen ? "down" : "right"
    }), props.title), isOpen && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.createElement(CardSection, {
        $style: {
            paddingTop: $theme.sizing.scale0,
            paddingLeft: `calc(${$theme.sizing.scale900} - ${$theme.sizing.scale0})`,
            paddingRight: $theme.sizing.scale500
        }
    }, props.children));
};


/***/ }),

/***/ 49325:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   K: () => (/* binding */ AccordionExpandIcon)
/* harmony export */ });
/* harmony import */ var baseui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(10334);
/* harmony import */ var baseui_icon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74995);
/* harmony import */ var lodash_omit__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73352);
/* harmony import */ var lodash_omit__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_omit__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30242);




const AccordionExpandIcon = (props)=>{
    const [_css, $theme] = (0,baseui__WEBPACK_IMPORTED_MODULE_2__/* .useStyletron */ .hQ)();
    let rotation = 0;
    if (props.direction == "down") {
        rotation = 90;
    } else if (props.direction == "left") {
        rotation = 180;
    } else if (props.direction == "up") {
        rotation = -90;
    }
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createElement(baseui_icon__WEBPACK_IMPORTED_MODULE_3__/* .Svg */ .n, {
        viewBox: "0 0 30 30",
        ...lodash_omit__WEBPACK_IMPORTED_MODULE_0___default()(props, "direction")
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createElement("path", {
        d: "M20.625 15.0001C20.625 15.1974 20.5494 15.3948 20.3991 15.5451L12.6908 23.2534C12.4704 23.4738 12.1389 23.5401 11.8506 23.4207C11.5623 23.3019 11.375 23.0198 11.375 22.7084V7.29179C11.375 6.98037 11.5623 6.69825 11.8506 6.57954C12.1389 6.46006 12.4704 6.52635 12.6908 6.74681L20.3991 14.4551C20.5494 14.6054 20.625 14.8028 20.625 15.0001Z",
        fill: props.color || $theme.colors.contentSecondary,
        transform: `rotate(${rotation} 15 15)`
    }));
};


/***/ }),

/***/ 65370:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   K: () => (/* binding */ CheckmarkIcon)
/* harmony export */ });
/* harmony import */ var baseui_icon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74995);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30242);


const CheckmarkIcon = (props)=>{
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(baseui_icon__WEBPACK_IMPORTED_MODULE_1__/* .Svg */ .n, {
        viewBox: "0 0 17 16",
        ...props
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
        d: "M15.4528 4.28832C15.5652 4.17849 15.642 4.03738 15.6731 3.8833C15.7044 3.72859 15.6883 3.56802 15.6268 3.42265C15.5652 3.27728 15.4612 3.15388 15.3284 3.06864C15.1955 2.98339 15.04 2.94027 14.8822 2.94492C14.6794 2.95096 14.4867 3.03549 14.345 3.18066L6.36668 11.159L3.18883 7.98112C3.11704 7.90688 3.03128 7.84756 2.93647 7.80658C2.84081 7.76524 2.73785 7.74339 2.63364 7.74233C2.52943 7.74127 2.42605 7.76102 2.32957 7.80041C2.23308 7.8398 2.14543 7.89805 2.07173 7.97174C1.99804 8.04543 1.93979 8.13309 1.9004 8.22958C1.86101 8.32606 1.84127 8.42944 1.84233 8.53365C1.84339 8.63786 1.86523 8.74081 1.90658 8.83648C1.94755 8.93129 2.00687 9.01705 2.08111 9.08884L5.81282 12.8205C5.95972 12.9674 6.15897 13.0499 6.36668 13.0499C6.57439 13.0499 6.7736 12.9674 6.9205 12.8206L15.4528 4.28832Z",
        fill: "currentColor"
    }));
};


/***/ }),

/***/ 55934:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   E: () => (/* binding */ DownLeftArrowIcon)
/* harmony export */ });
/* harmony import */ var baseui_icon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74995);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30242);


const DownLeftArrowIcon = (props)=>{
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(baseui_icon__WEBPACK_IMPORTED_MODULE_1__/* .Svg */ .n, {
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
        d: "M1.50791 2.65924C1.6404 2.66131 1.76666 2.71589 1.85895 2.81098C1.95123 2.90607 2.002 3.0339 2.0001 3.1664V8.1664C2.0001 8.63248 2.36736 8.99974 2.83343 8.99974H13.2931L10.8132 6.51992C10.7411 6.44967 10.6919 6.35927 10.672 6.26057C10.652 6.16187 10.6624 6.05946 10.7017 5.96673C10.7409 5.87401 10.8072 5.7953 10.892 5.7409C10.9767 5.6865 11.0759 5.65895 11.1765 5.66184C11.3064 5.66563 11.4297 5.7198 11.5203 5.81289L14.8536 9.14622C14.9473 9.23999 15 9.36715 15 9.49973C15 9.63232 14.9473 9.75948 14.8536 9.85325L11.5203 13.1866C11.4742 13.2346 11.419 13.2729 11.358 13.2993C11.2969 13.3257 11.2312 13.3396 11.1647 13.3403C11.0981 13.341 11.0322 13.3284 10.9706 13.3032C10.909 13.2781 10.853 13.2409 10.806 13.1938C10.7589 13.1468 10.7218 13.0909 10.6966 13.0293C10.6715 12.9677 10.6589 12.9017 10.6596 12.8352C10.6602 12.7687 10.6742 12.7029 10.7006 12.6419C10.727 12.5808 10.7653 12.5256 10.8132 12.4796L13.2931 9.99973H2.83343C1.82684 9.99973 1.0001 9.17299 1.0001 8.1664V3.1664C0.999138 3.09948 1.01162 3.03305 1.03681 2.97104C1.062 2.90903 1.09938 2.85271 1.14673 2.80541C1.19409 2.75812 1.25046 2.72081 1.3125 2.6957C1.37454 2.67059 1.44099 2.65819 1.50791 2.65924Z"
    }));
};


/***/ }),

/***/ 65699:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   h: () => (/* binding */ ExternalLinkIcon)
/* harmony export */ });
/* unused harmony export ExternalLinkIconBox */
/* harmony import */ var baseui_icon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74995);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30242);


// Arrow pointing through the top right corner of a square outline
const ExternalLinkIcon = (props)=>/*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(baseui_icon__WEBPACK_IMPORTED_MODULE_1__/* .Svg */ .n, {
        viewBox: "0 0 16 16",
        ...props
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
        d: "M13.653 1.66042C13.6284 1.66123 13.6038 1.66341 13.5794 1.66693H9.33268C9.24434 1.66568 9.15663 1.68201 9.07465 1.71495C8.99267 1.74789 8.91806 1.7968 8.85515 1.85883C8.79223 1.92086 8.74228 1.99477 8.70818 2.07628C8.67408 2.15778 8.65652 2.24525 8.65652 2.3336C8.65652 2.42195 8.67408 2.50942 8.70818 2.59092C8.74228 2.67243 8.79223 2.74634 8.85515 2.80837C8.91806 2.8704 8.99267 2.91931 9.07465 2.95225C9.15663 2.9852 9.24434 3.00152 9.33268 3.00027H12.0566L7.528 7.52891C7.46401 7.59034 7.41293 7.66392 7.37774 7.74534C7.34255 7.82676 7.32396 7.91438 7.32305 8.00308C7.32215 8.09177 7.33896 8.17975 7.37248 8.26187C7.40601 8.34399 7.45558 8.4186 7.5183 8.48131C7.58102 8.54403 7.65562 8.59361 7.73774 8.62713C7.81986 8.66066 7.90785 8.67746 7.99654 8.67656C8.08523 8.67566 8.17286 8.65707 8.25427 8.62188C8.33569 8.58669 8.40927 8.5356 8.4707 8.47162L12.9993 3.94298V6.66693C12.9981 6.75528 13.0144 6.84298 13.0474 6.92496C13.0803 7.00694 13.1292 7.08156 13.1912 7.14447C13.2533 7.20738 13.3272 7.25734 13.4087 7.29144C13.4902 7.32554 13.5777 7.3431 13.666 7.3431C13.7544 7.3431 13.8418 7.32554 13.9233 7.29144C14.0048 7.25734 14.0788 7.20738 14.1408 7.14447C14.2028 7.08156 14.2517 7.00694 14.2847 6.92496C14.3176 6.84298 14.3339 6.75528 14.3327 6.66693V2.41563C14.3455 2.31985 14.3374 2.22241 14.3089 2.13007C14.2804 2.03774 14.2321 1.9527 14.1675 1.88087C14.1028 1.80903 14.0233 1.75211 13.9345 1.71405C13.8456 1.67598 13.7496 1.65769 13.653 1.66042ZM4.16602 2.66693C2.79358 2.66693 1.66602 3.7945 1.66602 5.16693V11.8336C1.66602 13.206 2.79358 14.3336 4.16602 14.3336H10.8327C12.2051 14.3336 13.3327 13.206 13.3327 11.8336V8.66693C13.3339 8.57859 13.3176 8.49088 13.2847 8.40891C13.2517 8.32693 13.2028 8.25231 13.1408 8.1894C13.0788 8.12649 13.0048 8.07653 12.9233 8.04243C12.8418 8.00833 12.7544 7.99077 12.666 7.99077C12.5777 7.99077 12.4902 8.00833 12.4087 8.04243C12.3272 8.07653 12.2533 8.12649 12.1912 8.1894C12.1292 8.25231 12.0803 8.32693 12.0474 8.40891C12.0144 8.49088 11.9981 8.57859 11.9993 8.66693V11.8336C11.9993 12.4825 11.4816 13.0003 10.8327 13.0003H4.16602C3.51712 13.0003 2.99935 12.4825 2.99935 11.8336V5.16693C2.99935 4.51804 3.51712 4.00027 4.16602 4.00027H7.33268C7.42102 4.00152 7.50873 3.9852 7.59071 3.95225C7.67269 3.91931 7.7473 3.8704 7.81022 3.80837C7.87313 3.74634 7.92309 3.67243 7.95719 3.59092C7.99128 3.50942 8.00884 3.42195 8.00884 3.3336C8.00884 3.24525 7.99128 3.15778 7.95719 3.07628C7.92309 2.99477 7.87313 2.92086 7.81022 2.85883C7.7473 2.7968 7.67269 2.74789 7.59071 2.71495C7.50873 2.68201 7.42102 2.66568 7.33268 2.66693H4.16602Z"
    }));
// Solid colored box with an internal arrow pointing to top right corner
const ExternalLinkIconBox = (props)=>/*#__PURE__*/ React.createElement(StyledSvg, {
        viewBox: "0 0 16 16",
        ...props
    }, /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M12.1667 2H3.83333C2.82233 2 2 2.82267 2 3.83333V12.1667C2 13.1773 2.82233 14 3.83333 14H12.1667C13.1777 14 14 13.1773 14 12.1667V3.83333C14 2.82267 13.1777 2 12.1667 2ZM12 8.16667C12 8.44267 11.7763 8.66667 11.5 8.66667C11.2237 8.66667 11 8.44267 11 8.16667V5.707L5.85367 10.8537C5.756 10.9513 5.628 11 5.5 11C5.372 11 5.244 10.9513 5.14633 10.8537C4.951 10.6583 4.951 10.342 5.14633 10.1467L10.293 5H7.83333C7.557 5 7.33333 4.776 7.33333 4.5C7.33333 4.224 7.557 4 7.83333 4H11.5C11.7763 4 12 4.224 12 4.5V8.16667Z"
    })));


/***/ }),

/***/ 69811:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  M: () => (/* binding */ GadgetLogoMark),
  u: () => (/* binding */ GadgetLogoType)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@0.0.0-experimental-4ead6b530/node_modules/react/index.js
var react = __webpack_require__(30242);
;// CONCATENATED MODULE: ../@gadgetinc/widgets/assets/logomark.svg
/* harmony default export */ const logomark = (__webpack_require__.p + "1b5b906861f70ec70ea51c35c1e023be.svg");
;// CONCATENATED MODULE: ../@gadgetinc/widgets/assets/logotype.svg
/* harmony default export */ const logotype = (__webpack_require__.p + "13513703c5b41ce947547e20671b9409.svg");
;// CONCATENATED MODULE: ../@gadgetinc/widgets/src/icons/GadgetLogo.tsx



const GadgetLogoType = (props)=>{
    return /*#__PURE__*/ react.createElement("img", {
        ...props,
        src: logotype
    });
};
const GadgetLogoMark = (props)=>{
    return /*#__PURE__*/ react.createElement("img", {
        ...props,
        src: logomark
    });
};


/***/ }),

/***/ 20277:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   X: () => (/* binding */ SmallArrowIcon)
/* harmony export */ });
/* harmony import */ var baseui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10334);
/* harmony import */ var baseui_icon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74995);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30242);



const SmallArrowIcon = (props)=>{
    const [_, $theme] = (0,baseui__WEBPACK_IMPORTED_MODULE_1__/* .useStyletron */ .hQ)();
    let rotation = 0;
    if (props.direction == "down") {
        rotation = 90;
    } else if (props.direction == "left") {
        rotation = 180;
    } else if (props.direction == "up") {
        rotation = -90;
    }
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(baseui_icon__WEBPACK_IMPORTED_MODULE_2__/* .Svg */ .n, {
        viewBox: "0 0 16 16",
        ...props
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
        d: "M8.068 11.244L10.658 8.65401H3V7.33801H10.658L8.068 4.762L8.95 3.88L13.08 8.01L8.95 12.126L8.068 11.244Z",
        fill: props.color ?? (props.$disabled ? $theme.colors.contentStateDisabled : "currentcolor"),
        style: {
            transform: `rotate3d(0, 0, 1, ${rotation}deg)`,
            transformOrigin: "center"
        }
    }));
};


/***/ }),

/***/ 37307:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   QG: () => (/* binding */ useOverrides)
/* harmony export */ });
/* unused harmony exports getOverrides, BasewebSelectVerbose */
/* harmony import */ var lodash_mapValues__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61230);
/* harmony import */ var lodash_mapValues__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_mapValues__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lodash_values__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31682);
/* harmony import */ var lodash_values__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_values__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30242);



function maybeMerge(a, b) {
    return a && b ? {
        ...a,
        ...b
    } : a || b;
}
const getOverrides = (override, Component, props)=>{
    // component override shortcut:
    if (typeof override === "function") {
        Component = override;
    } else if (override) {
        const { style, props: propsOverride, component } = override;
        // assume at least one of the folllowing will override props, so clone
        props = {
            ...props
        };
        // component override:
        if (component) {
            Component = component;
        }
        // props override:
        if (propsOverride) {
            Object.assign(props, propsOverride);
        }
        // style override:
        if (style) {
            props.style = maybeMerge(props.style, typeof style === "function" ? style(props) : style);
        // TODO: support $style?
        // props.$style = style;
        }
    // nested overrides:
    // if (Object.keys(nested).length > 0) {
    //   props.overrides = maybeMerge(props.overrides, nested);
    // }
    }
    return [
        Component,
        props
    ];
};
const createOverridenComponent = (name, Component, getOverrideForRender)=>{
    const wrapped = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.forwardRef((props, ref)=>{
        const override = getOverrideForRender();
        if (override) {
            const [NewComponent, mergedProps] = getOverrides(override, Component, props);
            return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.createElement(NewComponent, {
                ...mergedProps,
                ref: ref
            });
        } else {
            return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.createElement(Component, {
                ...props,
                ref: ref
            });
        }
    });
    wrapped.displayName = `${name}WithOverrides`;
    return wrapped;
};
const useOverrides = (defaultComponents, overrides = {})=>{
    const overridesRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(overrides);
    overridesRef.current = overrides;
    const x = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(()=>{
        return lodash_mapValues__WEBPACK_IMPORTED_MODULE_0___default()(defaultComponents, (value, name)=>createOverridenComponent(name, defaultComponents[name], ()=>overridesRef.current[name]));
    }, lodash_values__WEBPACK_IMPORTED_MODULE_1___default()(defaultComponents)); // eslint-disable-line react-hooks/exhaustive-deps
    return x;
};
/**
 * For a better DevTools inspection experience
 */ const BasewebSelectVerbose = Object.assign({}, ...[
    "Root",
    "ControlContainer",
    "Placeholder",
    "ValueContainer",
    "SingleValue",
    "MultiValue",
    "Tag",
    "InputContainer",
    "Input",
    "IconsContainer",
    "SelectArrow",
    "ClearIcon",
    "LoadingIndicator",
    "SearchIconContainer",
    "SearchIcon",
    "Popover",
    "DropdownContainer",
    "Dropdown",
    "DropdownOption",
    "DropdownListItem",
    "OptionContent",
    "StatefulMenu"
].map((override)=>({
        [override]: {
            props: {
                "data-baseweb-id": override
            }
        }
    })));


/***/ }),

/***/ 10424:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   tv: () => (/* binding */ useRouter),
/* harmony export */   uW: () => (/* binding */ routingStore)
/* harmony export */ });
/* unused harmony export RouterContext */
/* harmony import */ var _superwf_mobx_react_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94278);
/* harmony import */ var _superwf_mobx_react_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_superwf_mobx_react_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var history__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86380);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30242);



const browserHistory = (0,history__WEBPACK_IMPORTED_MODULE_2__.createBrowserHistory)();
const routingStore = new _superwf_mobx_react_router__WEBPACK_IMPORTED_MODULE_0__.RouterStore(browserHistory);
const RouterContext = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createContext(routingStore);
const useRouter = ()=>react__WEBPACK_IMPORTED_MODULE_1__.useContext(RouterContext);


/***/ }),

/***/ 51654:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  id: () => (/* binding */ DeployAwareEnvironmentNameTag),
  mK: () => (/* binding */ EnvironmentNameLabel),
  Kk: () => (/* binding */ EnvironmentNamePill),
  hu: () => (/* binding */ EnvironmentNameTag),
  Fx: () => (/* binding */ EnvironmentNameTags)
});

// EXTERNAL MODULE: ../@gadgetinc/widgets/src/components/Row.tsx
var Row = __webpack_require__(73830);
// EXTERNAL MODULE: ../@gadgetinc/widgets/src/components/Pill.tsx + 1 modules
var Pill = __webpack_require__(3287);
// EXTERNAL MODULE: ../@gadgetinc/widgets/src/icons/DownLeftArrowIcon.tsx
var DownLeftArrowIcon = __webpack_require__(55934);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@0.0.0-experimental-4ead6b530/node_modules/react/index.js
var react = __webpack_require__(30242);
// EXTERNAL MODULE: ../@gadgetinc/widgets/src/icons/SmallArrowIcon.tsx
var SmallArrowIcon = __webpack_require__(20277);
;// CONCATENATED MODULE: ../@gadgetinc/widgets/src/icons/ForwardArrowIcon.tsx


const ForwardArrowIcon = (props)=>/*#__PURE__*/ react.createElement(SmallArrowIcon/* SmallArrowIcon */.X, {
        direction: "right",
        ...props
    });

// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/styles/styled.js
var styled = __webpack_require__(10334);
// EXTERNAL MODULE: ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/omit.js
var omit = __webpack_require__(73352);
var omit_default = /*#__PURE__*/__webpack_require__.n(omit);
// EXTERNAL MODULE: ../../node_modules/.pnpm/mobx-react-lite@4.0.7_mobx@6.13.2_react-dom@0.0.0-experimental-4ead6b530_react@0.0.0-experimental-4ead6b530/node_modules/mobx-react-lite/es/index.js + 13 modules
var es = __webpack_require__(25438);
// EXTERNAL MODULE: ../state-trees/src/Environment.ts
var Environment = __webpack_require__(5994);
// EXTERNAL MODULE: ./src/components/edit/workspace/EnvironmentContext.tsx
var EnvironmentContext = __webpack_require__(83656);
;// CONCATENATED MODULE: ./src/components/edit/editor/environment/EnvironmentNameTag.tsx









const DeployAwareEnvironmentNameTag = (0,es/* observer */.Pi)((props)=>{
    const [_, $theme] = (0,styled/* useStyletron */.hQ)();
    const prodRoot = (0,EnvironmentContext/* useProductionEnvironment */._F)();
    const prodSettings = prodRoot.settings.getOrSuspend();
    const isPublished = prodSettings.isEnvironmentActive;
    const isProduction = props.environment == Environment/* ProductionEnvironmentName */.KG;
    const pendingDeploy = isProduction && (!isPublished || props.pendingDeploy);
    return pendingDeploy ? /*#__PURE__*/ react.createElement(EnvironmentNameTag, omit_default()(props, "pendingDeploy"), /*#__PURE__*/ react.createElement(Row/* Row */.X, {
        $gap: $theme.sizing.scale200
    }, /*#__PURE__*/ react.createElement(ForwardArrowIcon, null), "pending deploy")) : /*#__PURE__*/ react.createElement(EnvironmentNameTag, props);
});
/**
 * Span which auto colors the text based on the environment name
 * No background
 **/ const EnvironmentNameTag = (props)=>{
    // eslint-disable-next-line react/no-unknown-property
    const isProduction = props.environment.toLowerCase() == "production";
    const [css, $theme] = (0,styled/* useStyletron */.hQ)();
    return /*#__PURE__*/ react.createElement(Pill/* Pill */.DR, {
        $color: isProduction ? "production" : "teal",
        title: props.environment.toLowerCase(),
        $style: {
            maxWidth: "100%",
            paddingLeft: isProduction ? $theme.sizing.scale100 : "3px"
        }
    }, /*#__PURE__*/ react.createElement("span", {
        className: css({
            color: isProduction ? $theme.colors.contentProduction : $theme.colors.contentDevelopment,
            fontWeight: 500,
            height: "20px",
            whiteSpace: "nowrap",
            maxWidth: "100%",
            ...props.$style
        }),
        "data-widget": "environment-name-tag",
        ...omit_default()(props, [
            "$style",
            "environment"
        ]),
        title: props.environment.toLowerCase()
    }, props.children ?? /*#__PURE__*/ react.createElement(EnvironmentNameLabel, {
        showArrowIcon: !isProduction && typeof window !== "undefined" && window.GadgetEditConfig?.multiEnvironmentEnabled,
        envName: props.environment
    })));
};
const EnvironmentNameLabel = (props)=>{
    const [css, $theme] = (0,styled/* useStyletron */.hQ)();
    return /*#__PURE__*/ react.createElement(react.Fragment, null, props.showArrowIcon && /*#__PURE__*/ react.createElement(DownLeftArrowIcon/* DownLeftArrowIcon */.E, {
        $style: {
            marginRight: $theme.sizing.scale200,
            maxHeight: $theme.sizing.scale600,
            verticalAlign: "text-bottom"
        }
    }), /*#__PURE__*/ react.createElement("span", {
        style: {
            overflow: "hidden",
            textOverflow: "ellipsis"
        }
    }, props.envName.toLowerCase()));
};
/**
 * Span which auto colors the text based on the environment name
 * Pill shaped with a background
 **/ const EnvironmentNamePill = (props)=>{
    const [_css, $theme] = (0,styled/* useStyletron */.hQ)();
    return /*#__PURE__*/ react.createElement(EnvironmentNameTag, {
        ...props,
        $style: {
            borderRadius: $theme.borders.radius200,
            padding: "0px 4px",
            ...props.$style
        }
    });
};
const EnvironmentNameTags = {
    Development: (props)=>/*#__PURE__*/ react.createElement(EnvironmentNameTag, {
            ...props,
            environment: Environment/* DevelopmentEnvironmentName */.y2
        }, "Development"),
    development: (props)=>/*#__PURE__*/ react.createElement(EnvironmentNameTag, {
            ...props,
            environment: Environment/* DevelopmentEnvironmentName */.y2
        }, "development"),
    Production: (props)=>/*#__PURE__*/ react.createElement(EnvironmentNameTag, {
            ...props,
            environment: Environment/* ProductionEnvironmentName */.KG
        }, "Production"),
    production: (props)=>/*#__PURE__*/ react.createElement(EnvironmentNameTag, {
            ...props,
            environment: Environment/* ProductionEnvironmentName */.KG
        }, "production")
};
EnvironmentNameTags.Development.textContent = "Development";
EnvironmentNameTags.development.textContent = "development";
EnvironmentNameTags.Production.textContent = "Production";
EnvironmentNameTags.production.textContent = "production";


/***/ }),

/***/ 83656:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   GP: () => (/* binding */ useCurrentEnvironment),
/* harmony export */   Gf: () => (/* binding */ useCurrentApplication),
/* harmony export */   Gq: () => (/* binding */ ApplicationRootContext),
/* harmony export */   H2: () => (/* binding */ ProductionEnvironmentRootContext),
/* harmony export */   Z3: () => (/* binding */ CurrentEnvironmentRootContext),
/* harmony export */   _F: () => (/* binding */ useProductionEnvironment),
/* harmony export */   j1: () => (/* binding */ useCurrentEnvironmentSettings)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30242);

const ApplicationRootContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);
const useCurrentApplication = ()=>(0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(ApplicationRootContext);
const CurrentEnvironmentRootContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);
const useCurrentEnvironment = ()=>(0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(CurrentEnvironmentRootContext);
const useCurrentEnvironmentSettings = ()=>useCurrentEnvironment().settings.getOrSuspend();
const ProductionEnvironmentRootContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);
const useProductionEnvironment = ()=>(0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(ProductionEnvironmentRootContext);


/***/ }),

/***/ 66500:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Cu: () => (/* binding */ maybeOpenUpgradeModal),
/* harmony export */   Gw: () => (/* binding */ removeQueryParams),
/* harmony export */   LQ: () => (/* binding */ useDocsRoute),
/* harmony export */   Qw: () => (/* binding */ getSearchParams),
/* harmony export */   cI: () => (/* binding */ removeYuckyQueryParams)
/* harmony export */ });
/* unused harmony export roundOutClipPath */
/* harmony import */ var lodash_range__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(38569);
/* harmony import */ var lodash_range__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_range__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(46163);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _EnvironmentContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83656);
/* harmony import */ var docs_src_chrome_FullMetaBlob__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(77886);




// rounded out corner setup: https://css-tricks.com/tabs-with-round-out-borders/
const roundOutClipPath = (points = 10, left = true, bottom = false)=>{
    let coords = range(points + 1).map((x)=>[
            x,
            Math.sqrt(points ** 2 - (left ? x : points - x) ** 2)
        ]); // get circle coords
    if (bottom) {
        coords = coords.map(([x, y])=>[
                x,
                points - y
            ]);
    }
    return `polygon(
    ${coords.map(([x, y])=>`${Math.round(x * 100 / points)}% ${Math.round(y * 100 / points)}%`).join(", ")},
    ${left ? bottom ? "100% 0%" : "100% 100%" : "0% 100%"}
  )`;
};
const maybeOpenUpgradeModal = (root, router)=>{
    const params = getSearchParams(router);
    if (params["upgradePlan"]) {
        root.currentEnvironment.upgradePlanModal.open();
        delete params["upgradePlan"];
    }
    replaceParams(router, params);
};
const YuckyParams = [
    "sessionboot",
    "gclid"
];
// Removes internal implementation params from the URL that devs have to stare at all day
const removeYuckyQueryParams = (router)=>{
    removeQueryParams(router, YuckyParams);
};
const removeQueryParams = (router, paramsToRemove)=>{
    const params = getSearchParams(router);
    for (const param of paramsToRemove){
        delete params[param];
    }
    replaceParams(router, params);
};
const replaceParams = (router, newParams)=>{
    let newPath = router.location.pathname;
    if (Object.keys(newParams).length > 0) {
        newPath += "?" + (0,qs__WEBPACK_IMPORTED_MODULE_1__.stringify)(newParams);
    }
    // add the hash (used for Readme files)
    if (router.location.hash) {
        newPath += router.location.hash;
    }
    router.history.replace(newPath);
};
//router.location.search unexpectedly includes the '?' as the first character of the query
const getSearchParams = (router)=>{
    let search = router.location.search;
    if (search.startsWith("?")) search = search.slice(1);
    return (0,qs__WEBPACK_IMPORTED_MODULE_1__.parse)(search);
};
const useDocsRoute = ()=>{
    const currentEnvSettings = (0,_EnvironmentContext__WEBPACK_IMPORTED_MODULE_2__/* .useCurrentEnvironmentSettings */ .j1)();
    const docsPrefix = docs_src_chrome_FullMetaBlob__WEBPACK_IMPORTED_MODULE_3__/* .DocsVersions */ .zh.find((docVersion)=>currentEnvSettings.frameworkVersion.satisfies(docVersion.frameworkRange))?.prefix;
    const generateDocsLink = (pathOrHref, options = {})=>{
        const url = new URL(pathOrHref, window.GadgetEditConfig.docsRootURL);
        if (!pathOrHref.includes("/guides")) {
            return url.toString();
        }
        url.searchParams.set("slug", currentEnvSettings.applicationSlug);
        if (docsPrefix && options.applyVersioning) {
            return url.toString().replace(window.GadgetEditConfig.docsRootURL, `${window.GadgetEditConfig.docsRootURL}${docsPrefix}`);
        } else {
            return url.toString();
        }
    };
    return {
        baseUrl: window.GadgetEditConfig.docsRootURL,
        generateDocsLink
    };
};


/***/ }),

/***/ 226:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   v: () => (/* binding */ playgroundConnectionOptions)
/* harmony export */ });
/* harmony import */ var lodash_merge__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88469);
/* harmony import */ var lodash_merge__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_merge__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var state_trees_src_Environment__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5994);


const isWindowAuthenticatedSession = window?.GadgetPlaygroundConfig?.authenticatedSession ?? false;
const baseEndpoint = "/api/graphql";
const playgroundConnectionOptions = (environment, isAuthenticatedSession = isWindowAuthenticatedSession)=>{
    const host = window.location.host;
    // authenticated requests use the Session cookie on production domain to make requests and use a header to specify the environment
    // unauthenticated requests must make requests directly to the appropriate environment domain
    let graphqlEndpoint = baseEndpoint;
    let graphqlWSEndpoint;
    if (!isAuthenticatedSession) {
        const domain = host.split(".")[0];
        const environmentAwareHost = host.replace(domain, environment.type === state_trees_src_Environment__WEBPACK_IMPORTED_MODULE_1__/* .EnvironmentType */ .Qj.Production ? domain : `${domain}--${environment.name}`);
        graphqlEndpoint = `https://${environmentAwareHost}${baseEndpoint}`;
        graphqlWSEndpoint = `wss://${environmentAwareHost}${baseEndpoint}/batch`;
    } else {
        graphqlWSEndpoint = `wss://${host}${baseEndpoint}/batch`;
    }
    return {
        environment: environment.type === state_trees_src_Environment__WEBPACK_IMPORTED_MODULE_1__/* .EnvironmentType */ .Qj.Production ? state_trees_src_Environment__WEBPACK_IMPORTED_MODULE_1__/* .ProductionEnvironmentName */ .KG : state_trees_src_Environment__WEBPACK_IMPORTED_MODULE_1__/* .DevelopmentEnvironmentName */ .y2,
        endpoint: graphqlEndpoint,
        websocketsEndpoint: graphqlWSEndpoint,
        authenticationMode: isAuthenticatedSession ? {
            custom: {
                async processFetch (_, init) {
                    init.credentials ??= "include";
                    lodash_merge__WEBPACK_IMPORTED_MODULE_0___default()(init.headers, {
                        "x-gadget-environment": environment.name,
                        "x-gadget-client": "graphql-playground"
                    });
                },
                async processTransactionConnectionParams (params) {
                    // don't pass "type": "custom" to the server -- just let the cookies do their thing
                    delete params.auth.type;
                }
            }
        } : {
            browserSession: true
        }
    };
};


/***/ }),

/***/ 4447:
/***/ ((__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) => {


// UNUSED EXPORTS: useThemeDetector

// EXTERNAL MODULE: ../@gadgetinc/widgets/src/DocsTheme.ts
var DocsTheme = __webpack_require__(17363);
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/helpers/base-provider.js
var base_provider = __webpack_require__(57040);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@0.0.0-experimental-4ead6b530/node_modules/react/index.js
var react = __webpack_require__(30242);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-dom@0.0.0-experimental-4ead6b530_react@0.0.0-experimental-4ead6b530/node_modules/react-dom/index.js
var react_dom = __webpack_require__(5556);
// EXTERNAL MODULE: ../../node_modules/.pnpm/styletron-react@6.0.2_react@0.0.0-experimental-4ead6b530/node_modules/styletron-react/dist/browser.es5.es.js
var browser_es5_es = __webpack_require__(81262);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@gadgetinc+api-client-core@0.15.33_bufferutil@4.0.6_utf-8-validate@5.0.9/node_modules/@gadgetinc/api-client-core/dist/esm/index.js + 17 modules
var esm = __webpack_require__(34441);
// EXTERNAL MODULE: ../@gadgetinc/widgets/src/components/Column.tsx
var Column = __webpack_require__(74888);
// EXTERNAL MODULE: ../@gadgetinc/widgets/src/components/Row.tsx
var Row = __webpack_require__(73830);
// EXTERNAL MODULE: ../@gadgetinc/widgets/src/utils/index.ts
var utils = __webpack_require__(1898);
// EXTERNAL MODULE: ../@gadgetinc/widgets/src/icons/GadgetLogo.tsx + 2 modules
var GadgetLogo = __webpack_require__(69811);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@graphiql+toolkit@0.9.1_@types+node@22.1.0_graphql-ws@5.14.1_graphql@16.8.1/node_modules/@graphiql/toolkit/esm/index.js + 14 modules
var toolkit_esm = __webpack_require__(72827);
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/styles/styled.js
var styled = __webpack_require__(10334);
// EXTERNAL MODULE: ../../node_modules/.pnpm/graphiql@3.0.5_@codemirror+language@6.10.2_@types+node@22.1.0_@types+react-dom@17.0.5_@types+_vmulqhc3ykmby5b6rq66asyrce/node_modules/graphiql/esm/index.js + 1 modules
var graphiql_esm = __webpack_require__(94682);
// EXTERNAL MODULE: ../../node_modules/.pnpm/mobx-react-lite@4.0.7_mobx@6.13.2_react-dom@0.0.0-experimental-4ead6b530_react@0.0.0-experimental-4ead6b530/node_modules/mobx-react-lite/es/index.js + 13 modules
var es = __webpack_require__(25438);
// EXTERNAL MODULE: ../state-trees/src/Environment.ts
var Environment = __webpack_require__(5994);
;// CONCATENATED MODULE: ./src/lib/playground.css
// extracted by mini-css-extract-plugin

// EXTERNAL MODULE: ./src/lib/useEmitReactReady.tsx
var useEmitReactReady = __webpack_require__(63396);
// EXTERNAL MODULE: ./src/components/edit/RoutingContext.tsx
var RoutingContext = __webpack_require__(10424);
// EXTERNAL MODULE: ./src/components/edit/workspace/utils.tsx
var workspace_utils = __webpack_require__(66500);
// EXTERNAL MODULE: ../@gadgetinc/widgets/src/components/button/Button.tsx
var Button = __webpack_require__(29919);
// EXTERNAL MODULE: ../@gadgetinc/widgets/src/components/Card.tsx
var Card = __webpack_require__(63582);
// EXTERNAL MODULE: ../@gadgetinc/widgets/src/EditTheme.ts
var EditTheme = __webpack_require__(37695);
// EXTERNAL MODULE: ../@gadgetinc/widgets/src/icons/AccordionExpandIcon.tsx
var AccordionExpandIcon = __webpack_require__(49325);
// EXTERNAL MODULE: ../@gadgetinc/widgets/src/icons/CheckmarkIcon.tsx
var CheckmarkIcon = __webpack_require__(65370);
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/popover/popover.js + 1 modules
var popover = __webpack_require__(2493);
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/popover/constants.js
var constants = __webpack_require__(64165);
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/typography/index.js
var typography = __webpack_require__(61022);
// EXTERNAL MODULE: ./src/components/edit/editor/environment/EnvironmentNameTag.tsx + 1 modules
var EnvironmentNameTag = __webpack_require__(51654);
;// CONCATENATED MODULE: ./src/components/playground/PlaygroundEnvironmentSelector.tsx










const developmentPillBackgroundColor = "#83A1C926";
const productionPillBackgroundColor = "#7D54E833";
const PlaygroundEnvironmentSelector = ({ environment, setEnvironment })=>{
    const [css, $theme] = (0,styled/* useStyletron */.hQ)();
    const isProdSelected = environment.type == Environment/* EnvironmentType */.Qj.Production;
    const [selectorIsOpen, setSelectorIsOpen] = (0,react.useState)(false);
    const closeMenu = ()=>setSelectorIsOpen(false);
    const envSelectorButtonActivatedStyle = {
        backgroundColor: "hsla(var(--color-neutral), var(--alpha-background-heavy))"
    };
    (0,react.useEffect)(()=>{
        if (isProdSelected) {
            document.body.classList.add("playground-prod");
        } else {
            document.body.classList.remove("playground-prod");
        }
    }, [
        isProdSelected
    ]);
    return /*#__PURE__*/ react.createElement("div", {
        className: css({
            ...(0,utils/* expandBorderRight */.XJ)({
                borderWidth: "1px",
                borderStyle: "solid",
                borderColor: "hsla(var(--color-neutral), var(--alpha-background-heavy))"
            }),
            ...(0,utils/* paddingHorizontal */.WB)(0, $theme.sizing.scale700)
        })
    }, /*#__PURE__*/ react.createElement("span", null, "Environment"), /*#__PURE__*/ react.createElement(popover/* default */.Z, {
        isOpen: selectorIsOpen,
        placement: constants/* PLACEMENT */.r4.bottomLeft,
        content: /*#__PURE__*/ react.createElement(MultiEnvironmentSelector, {
            environment: environment,
            setEnvironment: setEnvironment,
            onClose: closeMenu
        }),
        onClick: ()=>setSelectorIsOpen(!selectorIsOpen),
        onClickOutside: closeMenu,
        onEsc: closeMenu
    }, /*#__PURE__*/ react.createElement(Button/* Button */.zx, {
        kind: "primary",
        endEnhancer: /*#__PURE__*/ react.createElement(AccordionExpandIcon/* AccordionExpandIcon */.K, {
            direction: "down",
            color: "hsl(var(--color-neutral))"
        }),
        "data-testid": "playground-environment-selector",
        overrides: {
            BaseButton: {
                style: ({ $theme })=>({
                        marginLeft: $theme.sizing.scale500,
                        backgroundColor: "hsla(var(--color-neutral), var(--alpha-background-light))",
                        borderStyle: "solid",
                        borderWidth: "1px",
                        borderRadius: $theme.sizing.scale200,
                        borderColor: $theme.colors.contentSecondary,
                        ...selectorIsOpen ? envSelectorButtonActivatedStyle : undefined,
                        [Button/* ButtonHoverSelector */.aH]: envSelectorButtonActivatedStyle,
                        [":active:not(:disabled)"]: envSelectorButtonActivatedStyle
                    })
            }
        }
    }, /*#__PURE__*/ react.createElement("span", {
        className: css({
            fontFamily: EditTheme/* monoFontFamily */.CK,
            backgroundColor: isProdSelected ? productionPillBackgroundColor : developmentPillBackgroundColor,
            paddingLeft: $theme.sizing.scale100,
            paddingRight: $theme.sizing.scale100,
            paddingBottom: $theme.sizing.scale0,
            color: $theme.colors.contentPrimary,
            borderRadius: $theme.sizing.scale100,
            fontWeight: 500,
            fontSize: $theme.sizing.scale550,
            whiteSpace: "nowrap"
        })
    }, /*#__PURE__*/ react.createElement(EnvironmentNameTag/* EnvironmentNameLabel */.mK, {
        envName: environment.name.toLowerCase(),
        showArrowIcon: !isProdSelected
    })))));
};
const MultiEnvironmentSelector = ({ environment, setEnvironment, onClose })=>{
    const [css, $theme] = (0,styled/* useStyletron */.hQ)();
    const developmentEnvs = window.GadgetPlaygroundConfig.environments.filter((env)=>env.type === Environment/* EnvironmentType */.Qj.Development);
    const productionEnvs = window.GadgetPlaygroundConfig.environments.filter((env)=>env.type === Environment/* EnvironmentType */.Qj.Production);
    const onEnvSelect = (env)=>()=>{
            setEnvironment(env);
            onClose();
        };
    const envButtonStyle = {
        ":hover": {
            backgroundColor: "hsla(var(--color-neutral), var(--alpha-background-medium))"
        },
        backgroundColor: "transparent",
        borderStyle: "none",
        borderRadius: $theme.sizing.scale200,
        display: "inline-block",
        height: $theme.sizing.scale1000,
        color: $theme.colors.contentPrimary
    };
    return /*#__PURE__*/ react.createElement(Card/* Card */.Zb, {
        style: {
            textAlign: "center",
            width: "355px",
            backgroundColor: "hsl(var(--color-base))",
            borderColor: $theme.colors.primary600
        },
        tabIndex: -1,
        "data-testid": "playground-environment-list"
    }, /*#__PURE__*/ react.createElement(Card/* CardSection */.uO, {
        $padding: "small",
        $style: {
            borderBottom: `1px solid ${$theme.colors.alpha200}`
        }
    }, productionEnvs.map((env)=>/*#__PURE__*/ react.createElement(Row/* Row */.X, {
            $as: "button",
            onClick: onEnvSelect(env),
            $style: envButtonStyle,
            key: `production-environment-option-${env.slug}`,
            id: `production-environment-option-${env.slug}`
        }, /*#__PURE__*/ react.createElement(EnvironmentNamePillContainer, {
            envName: env.name.toLowerCase(),
            backgroundColor: productionPillBackgroundColor
        }), /*#__PURE__*/ react.createElement(SelectedEnvironmentCheckmark, {
            show: env.name === environment.name
        })))), /*#__PURE__*/ react.createElement(Card/* CardSection */.uO, {
        $padding: "small",
        $style: {
            gap: "0px",
            borderStyle: "solid",
            borderTopWidth: "1px",
            borderBottomWidth: 0,
            borderLeftWidth: 0,
            borderRightWidth: 0,
            borderColor: $theme.colors.primary700
        }
    }, developmentEnvs.length ? /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(typography/* LabelSmall */.S$, {
        $style: {
            color: $theme.colors.primary500,
            textAlign: "left",
            marginTop: $theme.sizing.scale300,
            marginBottom: $theme.sizing.scale300
        }
    }, "Development environments"), developmentEnvs.map((env)=>/*#__PURE__*/ react.createElement(Row/* Row */.X, {
            $as: "button",
            onClick: onEnvSelect(env),
            $style: envButtonStyle,
            key: `development-environment-option-${env.slug}`,
            id: `development-environment-option-${env.slug}`
        }, /*#__PURE__*/ react.createElement(EnvironmentNamePillContainer, {
            envName: env.name.toLowerCase(),
            showArrowIcon: true,
            backgroundColor: developmentPillBackgroundColor
        }), /*#__PURE__*/ react.createElement(SelectedEnvironmentCheckmark, {
            show: env.name === environment.name
        })))) : /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(typography/* LabelSmall */.S$, {
        $style: {
            color: $theme.colors.contentSecondary
        }
    }, "No environments found"))));
};
const EnvironmentNamePillContainer = ({ showArrowIcon, envName, backgroundColor })=>{
    const [css, $theme] = (0,styled/* useStyletron */.hQ)();
    return /*#__PURE__*/ react.createElement("div", {
        style: {
            height: "100%",
            float: "left",
            display: "flex",
            alignItems: "center"
        }
    }, /*#__PURE__*/ react.createElement("span", {
        style: {
            fontFamily: EditTheme/* monoFontFamily */.CK,
            paddingLeft: $theme.sizing.scale100,
            paddingRight: $theme.sizing.scale100,
            paddingBottom: $theme.sizing.scale0,
            borderRadius: $theme.sizing.scale100,
            backgroundColor
        }
    }, /*#__PURE__*/ react.createElement(EnvironmentNameTag/* EnvironmentNameLabel */.mK, {
        envName: envName,
        showArrowIcon: showArrowIcon
    })));
};
const SelectedEnvironmentCheckmark = ({ show })=>{
    return show ? /*#__PURE__*/ react.createElement(Row/* Row */.X, {
        $style: {
            float: "right",
            height: "100%"
        }
    }, /*#__PURE__*/ react.createElement(CheckmarkIcon/* CheckmarkIcon */.K, null)) : /*#__PURE__*/ react.createElement(react.Fragment, null);
};

// EXTERNAL MODULE: ../@gadgetinc/widgets/src/icons/ExternalLinkIcon.tsx
var ExternalLinkIcon = __webpack_require__(65699);
;// CONCATENATED MODULE: ./src/components/playground/PlaygroundHeaderContainer.tsx




const PlaygroundHeaderContainer = (props)=>{
    const [css, $theme] = (0,styled/* useStyletron */.hQ)();
    return /*#__PURE__*/ react.createElement(Row/* Row */.X, {
        className: `${css({
            height: "48px",
            backgroundColor: "hsl(var(--color-base));"
        })} graphiql-toolbar`
    }, /*#__PURE__*/ react.createElement(Row/* Row */.X, {
        $align: "space-between",
        className: css({
            flexGrow: 1,
            ...(0,utils/* expandBorderBottom */.lK)({
                borderColor: "hsla(var(--color-neutral), var(--alpha-background-heavy))",
                borderStyle: "solid",
                borderWidth: "1px"
            }),
            height: "100%"
        })
    }, /*#__PURE__*/ react.createElement(Row/* Row */.X, {
        className: css({
            ...$theme.typography.LabelSmall,
            color: "hsl(var(--color-neutral))",
            ...(0,utils/* paddingHorizontal */.WB)($theme.sizing.scale500)
        })
    }, props.children), /*#__PURE__*/ react.createElement(Row/* Row */.X, {
        $gap: $theme.sizing.scale500,
        $style: {
            marginRight: $theme.sizing.scale500
        }
    }, /*#__PURE__*/ react.createElement("a", {
        className: css({
            display: "inline-flex",
            ...$theme.typography.LabelXSmall,
            color: "hsl(var(--color-neutral))",
            alignItems: "center",
            textDecoration: "none",
            ":hover": {
                textDecoration: "underline"
            }
        }),
        href: "/api/playground/javascript"
    }, /*#__PURE__*/ react.createElement("span", {
        className: css({
            whiteSpace: "nowrap"
        })
    }, "JS playground")), /*#__PURE__*/ react.createElement("a", {
        className: css({
            display: "inline-flex",
            ...$theme.typography.LabelXSmall,
            color: "hsl(var(--color-neutral))",
            alignItems: "center",
            textDecoration: "none",
            ":hover": {
                textDecoration: "underline"
            }
        }),
        href: `${window.GadgetPlaygroundConfig.docsRootURL}/guides?slug=${window.GadgetPlaygroundConfig.applicationSlug}`,
        target: "_blank",
        rel: "noreferrer"
    }, /*#__PURE__*/ react.createElement("span", {
        className: css({
            whiteSpace: "nowrap"
        })
    }, "API docs"), /*#__PURE__*/ react.createElement(ExternalLinkIcon/* ExternalLinkIcon */.h, {
        className: css({
            marginLeft: $theme.sizing.scale300
        })
    })))));
};

// EXTERNAL MODULE: ../../node_modules/.pnpm/@graphiql+react@0.19.3_@codemirror+language@6.10.2_@types+node@22.1.0_@types+react-dom@17.0.5_iwmydt5yuompjdbeetq7ml26ie/node_modules/@graphiql/react/dist/index.mjs + 90 modules
var dist = __webpack_require__(83797);
;// CONCATENATED MODULE: ./src/components/playground/PlaygroundLogsLinkFooter.tsx
/* eslint-disable react/jsx-no-target-blank */ 




const PlaygroundLogsLinkFooter = ()=>{
    const [css, $theme] = (0,styled/* useStyletron */.hQ)();
    const context = (0,dist/* useEditorContext */._i)({
        nonNull: true
    });
    let logsLink = null;
    if (context.responseEditor) {
        try {
            const value = context.responseEditor.getValue();
            const { extensions } = JSON.parse(value);
            logsLink = extensions?.logs;
        } catch (error) {
        // ignore
        }
    }
    if (!logsLink) {
        return null;
    }
    return /*#__PURE__*/ react.createElement("div", {
        className: css({
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-end",
            paddingTop: $theme.sizing.scale100
        })
    }, /*#__PURE__*/ react.createElement("a", {
        href: logsLink,
        target: "_blank",
        className: css({
            ...(0,utils/* paddingUtil */.N1)($theme.sizing.scale200, $theme.sizing.scale400),
            ...(0,utils/* expandMargin */.ds)($theme.sizing.scale100),
            color: "hsl(var(--color-neutral))",
            textDecoration: "none",
            display: "inline-flex",
            flexDirection: "row",
            alignItems: "center",
            gap: $theme.sizing.scale200,
            borderRadius: $theme.borders.radius200,
            [":hover"]: {
                backgroundColor: "hsla(var(--color-neutral), var(--alpha-background-heavy))"
            }
        })
    }, /*#__PURE__*/ react.createElement("span", null, "View logs"), " ", /*#__PURE__*/ react.createElement(ExternalLinkIcon/* ExternalLinkIcon */.h, null)));
};

// EXTERNAL MODULE: ./src/components/playground/utils.ts
var playground_utils = __webpack_require__(226);
// EXTERNAL MODULE: ../../node_modules/.pnpm/graphql-ws@5.14.1_graphql@16.8.1/node_modules/graphql-ws/lib/client.mjs
var client = __webpack_require__(79178);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-helmet@6.1.0_react@0.0.0-experimental-4ead6b530/node_modules/react-helmet/es/Helmet.js
var Helmet = __webpack_require__(55020);
;// CONCATENATED MODULE: ./src/components/playground/GraphQLPlayground.tsx




















const GraphiQLComponent = /*#__PURE__*/ (0,react.memo)(({ fetcher, query, variables })=>{
    const [css, $theme] = (0,styled/* useStyletron */.hQ)();
    return /*#__PURE__*/ react.createElement(graphiql_esm/* GraphiQL */.yB, {
        fetcher: fetcher,
        query: query,
        variables: variables
    }, /*#__PURE__*/ react.createElement(graphiql_esm/* GraphiQL */.yB.Logo, null, /*#__PURE__*/ react.createElement(GadgetLogo/* GadgetLogoMark */.M, {
        className: css({
            height: "auto",
            width: "30px",
            marginTop: $theme.sizing.scale300
        })
    })), /*#__PURE__*/ react.createElement(graphiql_esm/* GraphiQL */.yB.Footer, null, /*#__PURE__*/ react.createElement(PlaygroundLogsLinkFooter, null)));
});
const GraphQLPlayground = (0,es/* observer */.Pi)(()=>{
    const [css, $theme] = (0,styled/* useStyletron */.hQ)();
    (0,useEmitReactReady/* useEmitReactReady */.z)();
    const appName = window?.GadgetPlaygroundConfig?.applicationName ?? "Gadget";
    const router = (0,RoutingContext/* useRouter */.tv)();
    const params = (0,workspace_utils/* getSearchParams */.Qw)(router);
    const query = typeof params.query === "string" ? params.query : undefined;
    const variables = typeof params.variables === "string" ? params.variables : "";
    const environment = (0,react.useMemo)(()=>window.GadgetPlaygroundConfig.environments.find((env)=>env.name === params.environment || env.slug == params.environment) ?? window.GadgetPlaygroundConfig.environments.find((env)=>env.type === Environment/* EnvironmentType */.Qj.Development) ?? {
            name: Environment/* DevelopmentEnvironmentName */.y2,
            type: Environment/* EnvironmentType */.Qj.Development
        }, [
        params.environment
    ]);
    const setEnvironment = (0,react.useCallback)((environment)=>{
        const urlParams = new URLSearchParams(router.location.search);
        urlParams.set("environment", environment.name);
        router.history.replace(`${router.location.pathname}?${urlParams}`);
    }, []);
    const fetcher = (0,react.useMemo)(()=>{
        const options = (0,playground_utils/* playgroundConnectionOptions */.v)(environment);
        const connection = new esm/* GadgetConnection */.Qe(options);
        return (0,toolkit_esm/* createGraphiQLFetcher */.nq)({
            url: options.endpoint,
            wsClient: options.websocketsEndpoint ? (0,client/* createClient */.eI)({
                url: options.websocketsEndpoint,
                connectionParams: {
                    environment: environment.name
                }
            }) : undefined,
            fetch: connection.fetch
        });
    }, [
        environment
    ]);
    const isProduction = environment.type === Environment/* EnvironmentType */.Qj.Production;
    return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(Helmet/* Helmet */.q, null, /*#__PURE__*/ react.createElement("link", {
        rel: "icon",
        href: `${window.GadgetPlaygroundConfig.assetsRootURL}/assets/api-playground/${isProduction ? "prod" : "dev"}/favicon-32.png`
    })), /*#__PURE__*/ react.createElement(Column/* Column */.s, {
        className: css({
            height: "100vh"
        })
    }, /*#__PURE__*/ react.createElement(PlaygroundHeaderContainer, null, /*#__PURE__*/ react.createElement(PlaygroundEnvironmentSelector, {
        environment: environment,
        setEnvironment: setEnvironment
    }), /*#__PURE__*/ react.createElement(Row/* Row */.X, {
        className: css({
            ...$theme.typography.LabelSmall,
            color: "hsl(var(--color-neutral))",
            ...(0,utils/* marginHorizontal */.oM)($theme.sizing.scale700)
        })
    }, appName)), /*#__PURE__*/ react.createElement(Row/* Row */.X, {
        className: css({
            flexGrow: 1,
            overflow: "hidden"
        })
    }, /*#__PURE__*/ react.createElement(GraphiQLComponent, {
        fetcher: fetcher,
        query: query,
        variables: variables
    }))));
});

// EXTERNAL MODULE: ./src/lib/flags.ts + 1 modules
var flags = __webpack_require__(97888);
// EXTERNAL MODULE: ./src/lib/styletronEngine.tsx
var styletronEngine = __webpack_require__(81058);
;// CONCATENATED MODULE: ./src/graphql-playground.tsx









const THEME = {
    light: "light",
    dark: "dark"
};
const useThemeDetector = ()=>{
    const [isDarkTheme, setIsDarkTheme] = (0,react.useState)(false);
    (0,react.useEffect)(()=>{
        const getCurrentTheme = ()=>{
            if (document.body.classList.contains("graphiql-dark")) {
                return true;
            }
            if (document.body.classList.contains("graphiql-light")) {
                return false;
            }
            return window.matchMedia("(prefers-color-scheme: dark)").matches;
        };
        const observer = new MutationObserver(()=>{
            setIsDarkTheme(getCurrentTheme());
        });
        setIsDarkTheme(getCurrentTheme());
        observer.observe(document.body, {
            attributes: true
        });
        return ()=>{
            observer.disconnect();
        };
    }, []);
    return isDarkTheme;
};
function App() {
    const isDarkTheme = useThemeDetector();
    const [theme, setTheme] = (0,react.useState)(isDarkTheme ? THEME.dark : THEME.light);
    (0,react.useEffect)(()=>{
        setTheme(isDarkTheme ? THEME.dark : THEME.light);
    }, [
        isDarkTheme
    ]);
    return /*#__PURE__*/ react.createElement(react.StrictMode, null, /*#__PURE__*/ react.createElement(flags/* FlagsProvider */.Q_, {
        flags: flags/* CurrentFlags */.p
    }, /*#__PURE__*/ react.createElement(base_provider/* default */.Z, {
        theme: theme === THEME.dark ? DocsTheme/* DocsDarkTheme */.Tg : DocsTheme/* DocsLightTheme */.W6
    }, /*#__PURE__*/ react.createElement(browser_es5_es/* Provider */.zt, {
        value: styletronEngine/* styletronEngine */.F,
        debug: styletronEngine/* styletronDebug */.A
    }, /*#__PURE__*/ react.createElement(GraphQLPlayground, null)))));
}
react_dom.unstable_createRoot((0,utils/* assert */.hu)(document.getElementById("root"))).render(/*#__PURE__*/ react.createElement(App, null));


/***/ }),

/***/ 97888:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  p: () => (/* binding */ CurrentFlags),
  WN: () => (/* binding */ Flag),
  Q_: () => (/* binding */ FlagsProvider),
  P5: () => (/* binding */ useFlag),
  Vb: () => (/* binding */ useFlags)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/flag@4.4.0_@types+react-dom@17.0.5_@types+react@17.0.4_react-dom@0.0.0-experimental-4ead6b530_5wujmyu4zyhz3ob3w23lepq2am/node_modules/flag/build/index.js
var build = __webpack_require__(18988);
// EXTERNAL MODULE: ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/merge.js
var merge = __webpack_require__(88469);
var merge_default = /*#__PURE__*/__webpack_require__.n(merge);
// EXTERNAL MODULE: ../../node_modules/.pnpm/mobx@6.13.2/node_modules/mobx/dist/mobx.esm.js
var mobx_esm = __webpack_require__(28786);
// EXTERNAL MODULE: ../state-trees/src/type-system/FieldType.ts
var FieldType = __webpack_require__(54930);
;// CONCATENATED MODULE: ../state-trees/src/GadgetFlags.ts


/** Default flag state used for tests in state-trees and web */ const TestFlagDefaultState = {
    features: {
        fieldTypes: {
            [FieldType/* FieldType */.fS.Computed]: false,
            [FieldType/* FieldType */.fS.Color]: false,
            [FieldType/* FieldType */.fS.Money]: false
        },
        typescript: false,
        darkMode: false,
        defaultLanguageSelection: false,
        ideJSErrorChecking: false,
        actionsAsCode: false,
        fileBasedActions: false,
        computedViews: true,
        editorCodeGen: false,
        actionsExplainerPopup: false,
        shopifyPayloadFilters: false,
        stateInActionCode: false,
        codeMirrorEditor: false,
        shopifyCustomerAuthentication: false,
        elasticsearchSearchAPI: false,
        customerAuthenticationV2: false,
        computedFieldFiltering: true,
        bigCommerceConnection: true,
        editorAssistant: true,
        aiEarlyAdopters: false
    },
    internal: {
        websocketRateLimitMode: "enforce",
        canarySandbox: false,
        stagingLoki: false,
        rateLimitMode: "enforce",
        shopifyWebhookLoopDetection: false,
        upgradingFission: false,
        upgradingMainNodes: false,
        dedicatedColumnsStrategy: false,
        apiKeysInBrowserClients: true,
        throttleExchange: false,
        edgeFrameworkVersion: false,
        blackholeWebhooks: false,
        selectFrameworkVersionOnCreate: false,
        gellyVersion: "main",
        useTemporalBlueCluster: false,
        skipSearchVectorUpdate: false,
        gellyFilterSortCompiler: true
    }
};
const ClientSideDefaultFlags = merge_default()({}, TestFlagDefaultState, {
    features: {
        editorCodeGen: false
    }
});

;// CONCATENATED MODULE: ./src/lib/flags.ts





const { FlagsProvider, Flag, useFlag, useFlags } = (0,build/* default */.ZP)();
const CurrentFlags = (0,mobx_esm.observable)(typeof window === "undefined" ? ClientSideDefaultFlags : window.GadgetFlags);
if (typeof window !== "undefined") {
    /** Utility for setting flag values in tests */ window.mockFlags = (newFlags)=>{
        merge_default()(CurrentFlags, newFlags);
    };
}


/***/ }),

/***/ 81058:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (/* binding */ styletronDebug),
/* harmony export */   F: () => (/* binding */ styletronEngine)
/* harmony export */ });
/* harmony import */ var styletron_engine_monolithic__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96492);
/* harmony import */ var styletron_engine_monolithic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7085);
/* harmony import */ var styletron_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(81262);


const getHydrations = ()=>document.getElementsByClassName("_styletron_hydrate_");
const stylePrefix = "g-";
const styletronEngine = typeof window === "undefined" ? new styletron_engine_monolithic__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z({
    prefix: stylePrefix
}) : new styletron_engine_monolithic__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z({
    hydrate: getHydrations(),
    prefix: stylePrefix
});
const shouldNotDebug =  true || 0;
const styletronDebug = shouldNotDebug ? undefined : new styletron_react__WEBPACK_IMPORTED_MODULE_2__/* .DebugEngine */ .WA();


/***/ }),

/***/ 63396:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   z: () => (/* binding */ useEmitReactReady)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30242);

/**
 * Emit an event the first time we're rendered for anyone listening
 * Used by Cypress to wait for the react app to hydrate before running tests
 */ const useEmitReactReady = ()=>{
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        if (typeof window != "undefined") {
            // fire an event on the window when the layout mounts for cypress to know the app has booted
            window.dispatchEvent(new Event("gadget:react:ready"));
            window.gadgetReactReady = true;
        }
    }, []);
};


/***/ })

},
/******/ __webpack_require__ => { // webpackRuntimeModules
/******/ var __webpack_exec__ = (moduleId) => (__webpack_require__(__webpack_require__.s = moduleId))
/******/ __webpack_require__.O(0, [7556,6381,3592,2826,948,8334,5150,8473,1176,8741,7642,3349,5020,1681,3797,1924,8829,9260], () => (__webpack_exec__(4447)));
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ }
]);